import { doc, deleteDoc } from "firebase/firestore";
import { db } from "..";

const deleteComment = async (commentId) => {

    await deleteDoc(doc(db, "comments", commentId));
    
}

export default deleteComment